import ShoppingCartSearchComponent from 'components/desktop/ShoppingCart/Search/Index';

const ShoppingCartSearch = () => {
	return (
		<main className="container">
			<ShoppingCartSearchComponent />
		</main>
	);
};

export default ShoppingCartSearch;
